import React, { useContext } from "react";
import { rates } from "../../rbac-consts";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { default as AdminBaseRatesDetailsContainer } from "./admin/BaseRatesDetailsContainer";

const BaseRatesDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={rates.ADMIN}
      yes={() => (
        <AdminBaseRatesDetailsContainer match={match} />
      )}
    />
  );
};

export default BaseRatesDetailsWrapper;